import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Loader from "react-loader-spinner";

import * as restaurantAction from "../../actions/restaurantActions";
import * as networkAction from "../../actions/networkActions";

import Modal from "reboron/DropModal";
import { PageHeader } from "../../components/PageHeader";

import LoadingTable from "../../components/LoadingTable";
import RestaurantView from "../../components/RestaurantView";

import { formatDateTime, arrayIdsToName, formatAddress } from "../../helpers/utils";
import { Activity, checkUserActivity } from "../../helpers/userActivity";

import logoPrzelewy24 from "../../../assets/logo-przelewy-24.svg";

import { restaurantRouteBuilder, restaurantP24TransactionRouteBuilder } from "../../constants/routes";
import { Link } from "react-router-dom";

// Style object
const modalStyle = {
  width: '80%',
};

/**
 * Komponent zawierający kolekcję dostępnych restauracji.
 */
class Restaurants extends Component {

  constructor(props) {
    super(props);

    this.state = {
      // zawartosc modala (dodaj, edytuj, usun)
      modalContent: null,
      // czy dane do tabelki sie zaladowaly
      loading: true,
      // kolumy do tabelki
      tableColumns: this.getTableColumns()
    };
  }

  componentDidMount() {

    this._isMounted = true;

    //ladowanie danych do tabelki
    this.props.onFetch(() => {
      //po pobraniu danych do tabelki zmieniamy stan na zaladowany jesli jeszcze komponent jest aktywny
      if (this._isMounted) {
        this.setState({ loading: false });
      }
    });

    //ladowanie danych zaleznych do tabelki
    this.props.onDependentFetch();
  }

  componentDidUpdate(prevProps, prevState) {

    //aktualizujemy tylko wtedy kiedy zmienil sie stan sieci
    if (prevProps.networkList.length !== this.props.networkList.length) {
      this.setState({ tableColumns: this.getTableColumns() });
    }

  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * Tworzenie kolumn do tabelki
   */
  getTableColumns = () => {
    return [
      {
        Header: this.props.formatMessage("restaurant.id"),
        accessor: "id",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset", textAlign: "right" }
      },
      {
        Header: this.props.formatMessage("restaurant.name"),
        accessor: "name",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" }
      },
      {
        Header: this.props.formatMessage("restaurant.description"),
        accessor: "description",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" }
      },
      {
        Header: this.props.formatMessage("restaurant.clientName"),
        accessor: "clientName",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" }
      },
      {
        Header: this.props.formatMessage("restaurant.address"),
        id: "address",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" },
        accessor: data => {
          return formatAddress(data.streetName, data.streetNumber, data.localNumber, data.city, data.postCode);
        }
      },
      {
        Header: this.props.formatMessage("restaurant.networks"),
        id: "networkIds",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" },
        accessor: (data) => arrayIdsToName(data.networkIds, this.props.networkList),
        Cell: row => {
          if (this.props.networkList.length === 0) {
            return <Loader type="Watch" color="#1797be" height={18} width={18} />;
          }
          return <div>{row.value}</div>;
        }
      },
      {
        Header: this.props.formatMessage("restaurant.creationDate"),
        id: "creationDate",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" },
        maxWidth: 180,
        accessor: data => {
          return formatDateTime(data.creationDate);
        }
      },
      {
        Header: this.props.formatMessage("restaurant.modificationDate"),
        id: "modificationDate",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" },
        maxWidth: 180,
        accessor: data => {
          return formatDateTime(data.modificationDate);
        }
      },
      {
        Header: "",
        Cell: row => {

          const deleteButton = <button
            className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark"
            onClick={() => this.onRowDeleteClick(row.original)}
            title="Kasowanie restauracji"
          >
            <i className="fas fa-trash-alt" />
          </button>

          return (

            <div>
              <button
                className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark"
                onClick={() => this.onRowEditClick(row.original)}
                title="Edycja restauracji"
              >
                <i className="far fa-edit" />
              </button>

              {checkUserActivity(this.props.authenticatedUser, Activity.DELETE_RESTAURANT) && deleteButton}

              {/* szczegóły pojedyńczej restauracji */}

              <Link
                to={restaurantRouteBuilder(row.original.id)}
                className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark"
                title="Szczegóły"
              >
                {/*<i className="fas fa-angle-double-right"></i>*/}
                <i className="far fa-eye"></i>
              </Link>

              {/* platnosci przelewy24 pojedynczej restauracji */}
              <Link
                to={restaurantP24TransactionRouteBuilder(row.original.id)}
                title="Transakcje Przelewy24"
              >
                <img style={{ height: '20px' }} src={logoPrzelewy24} alt='Przelewy24' />
              </Link>

            </div>)
        }
      }
    ];
  }

  /**
   * Pokazuje modal
   */
  showModal() {
    this.refs.modal.show();
  }

  /**
   * Chowa modal
   */
  hideModal = () => {
    if (this.state.modalContent !== null) {
      this.setState({ modalContent: null });
      this.refs.modal.hide();
    }
  };

  /**
   * Akcja na klik przycisku dodania
   */
  onAddButtonClick = () => {
    //domyslmy model sieci
    let defaultRestaurant = {
      name: "",
      description: "",
      clientName: "",
      country: "",
      province: "",
      district: "",
      community: "",
      streetName: "",
      streetNumber: "",
      localNumber: "",
      city: "",
      postCode: "",
      post: "",
      phone1: "",
      email: "",
      url: "",
      countryNip: "",
      nip: "",
      regon: "",
      networkIds: []
    };
    this.setState({
      modalContent: (
        <RestaurantView
          title={this.props.formatMessage("app.restaurantPage.addRestaurant")}
          restaurant={defaultRestaurant}
          networkList={this.props.networkList}
          cancelText={this.props.formatMessage("app.action.cancel")}
          sumbitText={this.props.formatMessage("app.action.submit")}
          onCancel={this.hideModal}
          onSubmit={this.onCreateAction}
        />
      )
    });

    this.showModal();
  };

  /**
   * Akcja na klik edycji wiersza w tabelce
   */
  onRowEditClick = data => {
    //wlasciwosci ktorych nie mozemy edytowac
    const disableProperties = ["id"];

    this.setState({
      modalContent: (
        <RestaurantView
          title={this.props.formatMessage("app.restaurantPage.editRestaurant")}
          restaurant={data}
          networkList={this.props.networkList}
          cancelText={this.props.formatMessage("app.action.cancel")}
          sumbitText={this.props.formatMessage("app.action.submit")}
          onCancel={this.hideModal}
          onSubmit={this.onUpdateAction}
          disableProperties={disableProperties}
        />
      )
    });

    this.showModal();
  };

  /**
   * Akcja na klik kasowania wiersza w tabelce
   */
  onRowDeleteClick = data => {
    //wlasciwosci ktorych nie mozemy edytowac
    const disableProperties = ["id"];

    this.setState({
      modalContent: (
        <RestaurantView
          title={this.props.formatMessage("app.restaurantPage.deleteRestaurant")}
          restaurant={data}
          networkList={this.props.networkList}
          cancelText={this.props.formatMessage("app.action.cancel")}
          sumbitText={this.props.formatMessage("app.action.delete")}
          onCancel={this.hideModal}
          onSubmit={() => this.onDeleteAction(data)}
          disableProperties={disableProperties}
        />
      )
    });

    this.showModal();
  };

  /**
   * Akcja po zatwierdzeniu tworzenia
   */
  onCreateAction = data => {
    this.props.onCreate(data);
    this.hideModal();
  };

  /**
   * Akcja po zatwierdzeniu aktualizacji
   */
  onUpdateAction = data => {
    this.props.onUpdate(data);
    this.hideModal();
  };

  /**
   * Akcja po zatwierdzeniu kasowania
   */
  onDeleteAction = data => {
    this.props.onDelete(data);
    this.hideModal();
  };

  addButton() {
    return <button
      className="w3-btn w3-theme-dark"
      onClick={() => this.onAddButtonClick()}
    >
      {this.props.formatMessage("app.restaurantPage.addRestaurant")}
    </button>
  }

  render() {

    return (
      <div>
        <PageHeader text="app.restaurantPage.title" />

        {checkUserActivity(this.props.authenticatedUser, Activity.ADD_RESTAURANT) && this.addButton()}

        <Modal ref={"modal"} modalStyle={modalStyle}>{this.state.modalContent}</Modal>

        <LoadingTable
          data={this.props.restaurantList}
          columns={this.state.tableColumns}
          loading={this.state.loading}
        />
      </div>
    );
  }
}

Restaurants.propTypes = {
  formatMessage: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    restaurantList: state.restaurantReducer.restaurantList,
    networkList: state.networkReducer.networkList,
    authenticated: state.authReducer.authenticated,
    authenticatedUser: state.authReducer.authenticatedUser
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetch: callback => {
      dispatch(restaurantAction.fetchRestaurants(callback));
    },
    onDependentFetch: () => {
      dispatch(networkAction.fetchNetworks());
    },
    onDelete: restaurant => {
      dispatch(restaurantAction.deleteRestaurant(restaurant.id));
    },
    onCreate: restaurant => {
      dispatch(restaurantAction.createRestaurant(restaurant));
    },
    onUpdate: restaurant => {
      dispatch(restaurantAction.updateRestaurant(restaurant));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Restaurants);
